export { default } from './Discount';
